export enum LicenseType {
  CryptlexKey,
  CryptlexMetadata,
}
